'use client';

import React, { memo } from 'react';
import Image from 'next/image';

function AboutStory() {
  return (
    <section
      aria-labelledby="aboutstory-heading"
      className="w-full bg-white py-14 sm:py-16 lg:py-20"
    >
      <div className="mx-auto w-full max-w-[1240px] px-4 sm:px-6 md:px-8">
        {/* Top copy row: two columns on lg, stacked on mobile */}
        <div className="flex flex-col items-center text-center gap-8 max-w-4xl mx-auto">
          {/* Header block */}
          <header className="w-full">
            <h2
              id="aboutstory-heading"
              className="
                text-slate-900 font-extrabold tracking-tight
                text-[clamp(26px,5vw,40px)] leading-[1.25]
              "
            >
              From Humble Beginnings
              <br className="hidden sm:block" /> to Modern Label Manufacturing
            </h2>
          </header>

          {/* Paragraph block */}
          <div className="w-full">
            <p
              className="
                text-slate-700
                text-[clamp(16px,2.2vw,17.5px)]
                leading-[clamp(24px,3.3vw,28px)]
                mx-auto
                text-left
              "
            >
              Royal Prime Labels started with a simple goal, helping businesses create labels that improve product presentation and packaging performance. Over the years, we have grown into a trusted label manufacturing company with advanced flexographic printing systems, skilled operators and strong quality control processes.
              <br /><br />
              Today, we manufacture labels for businesses across FMCG, cosmetics, pharmaceuticals, food packaging, industrial products, logistics and retail sectors. Our focus remains the same, reliable production, consistent print output and long term business relationships.
            </p>
          </div>
        </div>

        {/* Image block */}
        <figure
          className="
            relative mt-10 sm:mt-12 lg:mt-14
            overflow-hidden rounded-[16px] bg-slate-100
          "
        >
          {/* Maintain generous margins + rounded corners like the screenshot */}
          <div className="relative w-full aspect-[16/9] sm:aspect-[3/2] lg:aspect-[21/10]">
            <Image
              src="/images/story-hero-v2.jpg"
              alt="Royal Prime Labels printing facility with multiple flexographic presses and workers operating the machines"
              fill
              priority={false}
              className="object-cover"
              sizes="(min-width:1024px) 1200px, 100vw"
            />
          </div>

          {/* Carousel dots (static, decorative) */}

        </figure>
      </div>
    </section>
  );
}

export default memo(AboutStory);
